import { Dialog, DialogActions, DialogTitle } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MenuItem from '@material-ui/core/MenuItem';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import * as authActions from 'app/auth/store/actions';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';


function UserMenu(props) {
	const dispatch = useDispatch();
	const user = useSelector(({ auth }) => auth.user);
	const user_data = useSelector(({ auth }) => auth.user.userData);

	const [userMenu, setUserMenu] = useState(null);
	const [open, setOpen] = React.useState(false);

	let isRole = null;
	const userData = JSON.parse(localStorage.getItem('userData'))
	if (userData && userData !== undefined && userData !== null && userData.userType) {
		isRole = userData.userType
	}
	console.log('user',userData);
	useEffect(() => {

		if (isRole && isRole === 'Owner') {
			dispatch(authActions.getUserData());
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};
	const logOutAgree = () => {
		dispatch(authActions.logoutUser());
		userMenuClose();
		setOpen(false);
	}
	const userMenuClick = event => {
		setUserMenu(event.currentTarget);
	};

	const userMenuClose = () => {
		setUserMenu(null);
	};
	// let isRole = null;
	// const userData = JSON.parse(localStorage.getItem('userData'))

	// if (userData && userData !== undefined && userData !== null && userData.userType) {
	// 	isRole = userData.userType
	// }
	return (
		<>
			<Button className="h-44 usermenu-opt" onClick={userMenuClick}>
				<div className="hidden md:flex flex-col mx-12 items-start">
					{/* {(isRole && isRole === 'Owner')
						?
						<Typography component="span" className="normal-case font-600 flex">
							{user_data && user_data.firstName + ' ' + user_data.lastName}
						</Typography>
						:
						<Typography component="span" className="normal-case font-600 flex">
							{user && user.firstName + ' ' + user.lastName}
						</Typography>

					} */}
					<Typography className="text-11 capitalize" color="textSecondary">
						{user.userType}
					</Typography>
				</div>
				{user_data && user_data.Path ? (
					<Avatar className="" alt="user photo" src={user_data.Path + user_data.profileImage} />
				) : (
					<Avatar className="" src="assets/images/avatars/profile.jpg" />
				)}
				{/* <Icon className="text-16 hidden sm:flex" variant="action">
					keyboard_arrow_down
				</Icon> */}
			</Button>

			<Popover
				open={Boolean(userMenu)}
				anchorEl={userMenu}
				onClose={userMenuClose}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'center'
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'center'
				}}
				classes={{
					paper: 'py-8'
				}}
			>
				{isRole && isRole === 'Owner' &&
					<>
						<MenuItem component={Link} to="/profile" onClick={userMenuClose} role="button">
							<ListItemIcon className="min-w-40">
								<Icon>account_circle</Icon>
							</ListItemIcon>
							<ListItemText primary="My Profile" />
						</MenuItem>
						<MenuItem component={Link} to="/support" onClick={userMenuClose} role="button">
							<ListItemIcon className="min-w-40">
								<Icon>help</Icon>
							</ListItemIcon>
							<ListItemText primary="Support" />
						</MenuItem>
					</>
				}
				{/* <MenuItem component={Link} to="/apps/mail" onClick={userMenuClose} role="button">
							<ListItemIcon className="min-w-40">
								<Icon>mail</Icon>
							</ListItemIcon>
							<ListItemText primary="Inbox" />
						</MenuItem> */}
				<MenuItem
					onClick={handleClickOpen}
				// onClick={() => {
				// 	dispatch(authActions.logoutUser());
				// 	userMenuClose();
				// }}
				>
					<ListItemIcon className="min-w-40">
						<Icon>exit_to_app</Icon>
					</ListItemIcon>
					<ListItemText primary="Logout" />
				</MenuItem>
				<Dialog
					open={open}
					onClose={handleClose}
					aria-labelledby="alert-dialog-title"
					aria-describedby="alert-dialog-description"
				>
					<DialogTitle id="alert-dialog-title">
						Are You sure you Want to Log-out?
					</DialogTitle>
					<DialogActions>
						<Button onClick={handleClose}>No</Button>
						<Button onClick={logOutAgree} autoFocus>
							Yes
						</Button>
					</DialogActions>
				</Dialog>
			</Popover>
		</>
	);
}

export default UserMenu;
